import { ReactElement, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import messages from '../../locales/messages';
import 'src/common/style/common.scss';
import { ThanksModal, thanksTable } from 'src/common/utils/ThanksModal';

export interface thanksProps {
  dataEngineers: number;
  meanTimeToDetect: number;
  meanTimeToResolve: number;
  hoursSaving: number;
  yearlySaving: string;
  threeYearSaving: string;
  focusLevel: string;
  bpName: string;
}
const Thanks = ({
  dataEngineers,
  meanTimeToDetect,
  meanTimeToResolve,
  hoursSaving,
  yearlySaving,
  threeYearSaving,
  focusLevel,
}: thanksProps): ReactElement => {
  const intl = useIntl();
  const titleThanks: thanksTable[] = [
    { group: 'title', value: intl.formatMessage(messages['thankyou.title']) },
    {
      group: 'subTitle',
      value: intl.formatMessage(messages['thankyou.subtitle']),
    },
  ];
  const widgetTitleThanks: thanksTable[] = [
    {
      group: 'widgetTitle1',
      value: intl.formatMessage(messages['thankyou.details-title']),
    },
  ];
  const contentThanks: thanksTable[] = [
    {
      group: String(intl.formatMessage(messages['triggertext_data_engineers'])),
      value: String(dataEngineers),
    },
    {
      group: String(intl.formatMessage(messages['triggertext_MTTD'])),
      value: String(meanTimeToDetect),
    },
    {
      group: String(intl.formatMessage(messages['triggertext_MTTR'])),
      value: String(meanTimeToResolve),
    },
    {
      group: String(intl.formatMessage(messages['focus_level_thankyou'])),
      value: String(focusLevel),
    },
    {
      group: String(intl.formatMessage(messages['hours_saved_year'])),
      value: String(hoursSaving),
    },
    {
      group: String(intl.formatMessage(messages['yearly_savings'])),
      value: String(yearlySaving),
    },
    {
      group: String(intl.formatMessage(messages['three_year_savings'])),
      value: String(threeYearSaving),
    },
  ];
  const buttonThanks: thanksTable[] = [
    {
      group: 'button1',
      value: String(intl.formatMessage(messages['return-to-estimator'])),
    },
  ];
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setShowModal(true);
  }, [dataEngineers, meanTimeToDetect, meanTimeToResolve]);
  return (
    <ThanksModal
      showThanksModal={showModal}
      pageTitle="Databand ROI Page"
      object="Databand ROI Page"
      productTitle={'Databand ROI estimator'}
      pageUrl={''}
      location={'Databand ROI Estimator'}
      titleThanks={titleThanks}
      widgetTitleThanks={widgetTitleThanks}
      contentThanks={contentThanks}
      buttonThanks={buttonThanks}
      setShowThanksModal={setShowModal}
    ></ThanksModal>
  );
};

export default Thanks;
